import { useParams } from "react-router";
import { useGetSpecificListingQuery } from "../../store/listing/fetchSpecialListing";
import Slider from "../../components/Slider/Slider";
import styles from "./SelectedListing.module.css";
import { IoLocation } from "react-icons/io5";
import Button from "../../components/Button/Button";
import { FaBed } from "react-icons/fa";
import { FaBath } from "react-icons/fa";
import { FaSquareParking } from "react-icons/fa6";
import { FaChair } from "react-icons/fa6";
import Map from "../../components/Map/Map";
import ClipLoader from "react-spinners/esm/ClipLoader";
import loadingStyles from "../../shared-styles/loading.module.css";
export default function SelectedListing() {
  const { id } = useParams();
  console.log(id);

  const {
    data: currentListing,
    isLoading: fetchListingLoading,
    isError: fetchListingError
  } = useGetSpecificListingQuery(id ?? "");

  if (fetchListingLoading)
    return (
      <div className={loadingStyles.loading}>
        <ClipLoader loading size={200} color="#35a257" />
      </div>
    );
  if (fetchListingError) {
    return <p>Error Happen ...</p>;
  }

  console.log(currentListing?.fields?.images?.arrayValue?.values);

  return (
    <main>
      <section>
        <Slider
          images={currentListing?.fields?.images?.arrayValue?.values}
          isLoading={fetchListingLoading}
          isError={fetchListingError}
        />
      </section>
      <section className={`container ${styles.container}`}>
        <div className={styles.listing}>
          <h1>
            {currentListing.fields.propertyName.stringValue} - $
            {currentListing.fields.price.integerValue}
          </h1>
          <span>
            <span className={styles.location}>
              <IoLocation />
            </span>
            <span className={styles["locationDesc"]}>
              {" "}
              {currentListing.fields.address.stringValue}
            </span>
          </span>
          <div className={styles.sellRent}>
            <Button>for {currentListing.fields.sellRent.stringValue}</Button>
          </div>
          <div className={styles.desc}>
            <span>Description -</span>
            <span>{currentListing.fields.description.stringValue}</span>
          </div>
          <div className={styles.content}>
            <span className={styles.bed}>
              <span>
                <FaBed />
              </span>
              <span>{currentListing.fields.beds.integerValue}</span>
            </span>
            <span className={styles.bath}>
              <span>
                <FaBath />
              </span>
              <span>{currentListing.fields.baths.integerValue}Bath</span>
            </span>
            <span className={styles.Parking}>
              <span>
                <FaSquareParking />
              </span>
              <span>
                {currentListing.fields.parkingSpot.stringValue === "yes"
                  ? "yes parking"
                  : "no parking"}
              </span>
            </span>
            <span className={styles.chair}>
              <span>
                <FaChair />
              </span>
              <span>
                {currentListing.fields.furnished.stringValue === "no"
                  ? "Not furnished"
                  : "yes furnished"}
              </span>
            </span>
          </div>

          <Button className="primary">CONTACT LANDLORD</Button>
        </div>
        <div className={styles.map}>
          <Map
            lat={
              currentListing?.fields?.location?.mapValue?.fields?.lat
                ?.doubleValue
            }
            lng={
              currentListing?.fields?.location?.mapValue?.fields?.lng
                ?.doubleValue
            }
          />
        </div>
      </section>
    </main>
  );
}
